import { defineMessages } from 'react-intl-next';
export var nodeViewsMessages = defineMessages({
  mediaGroupDeleteLabel: {
    id: 'fabric.editor.mediaGroupDeleteLabel',
    defaultMessage: 'delete',
    description: 'a label for an icon that deletes media'
  }
});